import axios from 'axios'

export const fetchFees = (query) => {
  let parameters = ''
  if (query) parameters = query

  return axios
    .get(`/authenticated/fees?${parameters}`)
    .then((resp) => resp.data)
}

export const fetchFeesExcel = (query) => {
  let parameters = ''
  if (query) parameters = query

  return axios
    .get(`/authenticated/fees/excel?${parameters}`, {
      responseType: 'arraybuffer'
    })
    .then((resp) => resp.data)
}
